var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 9.43347H11.0065M12.6667 2.66732H4.13333C3.3866 2.66732 3.01323 2.66732 2.72801 2.81264C2.47713 2.94047 2.27315 3.14445 2.14533 3.39533C2 3.68055 2 4.05391 2 4.80065V11.2007C2 11.9474 2 12.3207 2.14533 12.606C2.27315 12.8569 2.47713 13.0608 2.72801 13.1887C3.01323 13.334 3.38659 13.334 4.13333 13.334H11.8667C12.6134 13.334 12.9868 13.334 13.272 13.1887C13.5229 13.0608 13.7269 12.8569 13.8547 12.606C14 12.3207 14 11.9474 14 11.2007V7.46733C14 6.7206 14 6.34721 13.8547 6.062C13.7269 5.81111 13.5229 5.60714 13.272 5.47931C12.9868 5.33399 12.6134 5.33399 11.8667 5.33399H4.66667M11.3005 9.43347C11.3005 9.59913 11.1662 9.73347 11.0005 9.73347C10.8349 9.73347 10.7005 9.59913 10.7005 9.43347C10.7005 9.2678 10.8349 9.13347 11.0005 9.13347C11.1662 9.13347 11.3005 9.2678 11.3005 9.43347Z",
    stroke: "#50CB25",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAmount);
export default __webpack_public_path__ + "static/media/orderAmount.1814530d8775182799f05557a3edbbc2.svg";
export { ForwardRef as ReactComponent };